import { useFormContext } from 'react-hook-form';
import { ArrowRight, ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { MultiSelect } from '@/components/MultiSelect';
import { useData } from '@/contexts/data';

import { BrandFormData, PhaseProps } from '@/pages/settings/content/brands-sectors/create/shared/types';

export default function Two({ onNext, onBack }: PhaseProps) {
  const { watch, setValue, formState: { errors } } = useFormContext<BrandFormData>();
  const { territories, territoriesLoading, topics, topicsLoading, contexts, contextsLoading } = useData();

  const watchedData = watch();

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Nova Marca</h2>
        <p className="text-gray-600">Adicione uma nova Marca ao Culture Monitor.</p>
      </div>

      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Contextos</h3>
          <p className="text-sm text-gray-600 mb-6">Preencha abaixo os Territórios, Tópicos e Contextos ativáveis que fazem parte da Marca.</p>
        </div>

        <div className="space-y-6">
          <div>
            <h4 className="text-base font-semibold text-gray-900 mb-2">Territórios Prioritários</h4>
            <p className="text-sm text-gray-600 mb-4">Escolha o(s) território(s) a qual a Marca corresponde.</p>
            <MultiSelect
              value={watchedData.territories || []}
              onChange={(ids) => setValue('territories', ids, { shouldValidate: true })}
              items={territories}
              placeholder="Selecione o(s) território(s)"
              loading={territoriesLoading}
            />
            {errors.territories && (
              <p className="text-red-500 text-xs mt-1">{errors.territories.message}</p>
            )}
          </div>

          <div>
            <h4 className="text-base font-semibold text-gray-900 mb-2">Tópicos Prioritários</h4>
            <p className="text-sm text-gray-600 mb-4">Escolha o(s) tópico(s) a qual a marca corresponde.</p>
            <MultiSelect
              value={watchedData.topics || []}
              onChange={(ids) => setValue('topics', ids, { shouldValidate: true })}
              items={topics}
              placeholder="Selecione o(s) tópico(s)"
              loading={topicsLoading}
            />
            {errors.topics && (
              <p className="text-red-500 text-xs mt-1">{errors.topics.message}</p>
            )}
          </div>

          <div>
            <h4 className="text-base font-semibold text-gray-900 mb-2">Contextos Culturais-Alvo</h4>
            <p className="text-sm text-gray-600 mb-4">Escolha o(s) contextos(s) a qual a marca corresponde.</p>
            <MultiSelect
              value={watchedData.contexts || []}
              onChange={(ids) => setValue('contexts', ids, { shouldValidate: true })}
              items={contexts}
              placeholder="Selecione o(s) contexto(s)"
              loading={contextsLoading}
            />
            {errors.contexts && (
              <p className="text-red-500 text-xs mt-1">{errors.contexts.message}</p>
            )}
          </div>

        </div>
      </div>

      <div className="flex justify-between">
        {onBack && (
          <Button
            type="button"
            variant="outline"
            onClick={onBack}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Button>
        )}
        
        <Button
          onClick={onNext}
          className="bg-gray-200 text-gray-800 hover:bg-gray-300 flex items-center gap-2"
        >
          Próximo
          <ArrowRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}